import { Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";

import { CreateRevisionAction } from "../CreateRevisionAction";

// TEMPORARY: manual-QA mount until the finding action drawer hosts
// CreateRevisionAction; remove with that integration. Pass ?findingId=...&matched=1.
export function CreateRevisionHarness() {
  const [params] = useSearchParams();
  const findingId = params.get("findingId") ?? "";
  const matched = params.get("matched") === "1";
  const cersFacilityId = params.get("cersFacilityId") ?? "";

  if (!findingId) return <Typography>Provide ?findingId=…</Typography>;

  return (
    <CreateRevisionAction
      findingId={findingId}
      isFacilityMatched={matched}
      cersFacilityId={cersFacilityId}
    />
  );
}
